import { render, staticRenderFns } from "./EncuestaView.vue?vue&type=template&id=097ad056&"
import script from "./EncuestaView.vue?vue&type=script&lang=ts&"
export * from "./EncuestaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports